import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TextField, Tooltip, CardMedia, Input } from "@mui/material";

import React, { useState } from "react";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import SearchBar from "../../components/SearchBar";
import AddQueries from "../../Modals/addqueries";
import AddTemplate from "../../Modals/addtemplate";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AddBouteekPoints from "../../Modals/addbouteekpoints";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AddTags from "../../Modals/addtags";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageSystemSettings = () => {

  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [valueTabs2, setValueTabs2] = React.useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const handleCloseModal1 = () => {
    setOpenTemplateModal(false);
  };
  const [openBouteekModal, setOpenBouteekModal] = useState(false);
  const handleCloseModal2 = () => {
    setOpenBouteekModal(false);
  };
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  // Tags tab state
  const [tags, setTags] = useState<string[]>(["Trending", "Reels", "Products", "Categories"]);
  const [tagSearchTerm, setTagSearchTerm] = useState("");
  const [openAddTagModal, setOpenAddTagModal] = useState(false);
  const [openEditTagModal, setOpenEditTagModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [selectedTagIndex, setSelectedTagIndex] = useState<number>(-1);

  const handleAddTag = (tagName: string) => {
    setTags((prev) => [...prev, tagName]);
  };

  const handleEditTag = (newName: string) => {
    setTags((prev) => prev.map((t, i) => (i === selectedTagIndex ? newName : t)));
  };

  const handleDeleteTag = (index: number) => {
    setTags((prev) => prev.filter((_, i) => i !== index));
  };

  const filteredTags = tags.filter((t) =>
    t.toLowerCase().includes(tagSearchTerm.toLowerCase())
  );

  return (
    <>
      <div className="main_title">
        <h1> Settings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Settings
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="AI Query Limits" {...a11yProps(0)} />
              <Tab label="Campaign Type" {...a11yProps(1)} />
              <Tab label="AI Templates" {...a11yProps(2)} />
              <Tab label="Bouteek Points" {...a11yProps(3)} />
              <Tab label="Featured Product" {...a11yProps(4)} />
              <Tab label="Refund period" {...a11yProps(5)} />
              <Tab label="Website Signup Banner" {...a11yProps(6)} />
              <Tab label="Tags" {...a11yProps(7)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="stats_boxes gap_m">

            {/* TOTAL QUERIES SOLD */}
            <a href="/manage-queries?sold=true" className="cards">
              <div className="data_top">
                <h2>
                  2,456
                  <p>Total Queries Sold</p>
                </h2>
                <figure className="active_order">
                  <ShoppingCartIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* TOTAL AMOUNT EARNED */}
            <a href="/earnings" className="cards">
              <div className="data_top">
                <h2>
                  ₹8,45,300
                  <p>Total Amount Earned</p>
                </h2>
                <figure className="sucess">
                  <CurrencyRupeeIcon fontSize="large" />
                </figure>
              </div>
            </a>

          </div>

          <div className="table_header mt_20">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
              </Box>
            </div>
            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => setOpenModal(true)}><AddIcon /> Add</Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>AI Queries</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {[
                  { id: 1, range: "50 Queries", amount: "$10" },
                  { id: 2, range: "200 Queries", amount: "$25" },
                  { id: 3, range: "500 Queries", amount: "$50" },
                ].map((row, idx) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{row.range}</TableCell>
                    <TableCell>{row.amount}</TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search Campaign..."
                />
              </Box>
            </div>

            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => navigate("add-campaign-type")}>
                <AddIcon /> Add
              </Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell> Title</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Features</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {[
                  {
                    id: 1,
                    title: "Discount Code",
                    description: "Discount for first-time purchasers",
                    features: [
                      "Add Products",
                      "Add Categories",
                      "Percentage Discount: 20%",
                      "Flat Discount: ₹100",
                    ],
                    type: "Free",
                    amount: "—",
                  },
                  {
                    id: 2,
                    title: "Flash Sale",
                    description: "Seasonal discount for all users",
                    features: [
                      "Add Products",
                      "Percentage Discount: 40%",
                      "Flat Discount: —",
                    ],
                    type: "Paid",
                    amount: "₹499",
                  },
                  {
                    id: 3,
                    title: "Bundle Deal",
                    description: "Discount only on selected categories",
                    features: [
                      "Add Categories",
                      "Percentage Discount: 15%",
                    ],
                    type: "Free",
                    amount: "—",
                  },
                ].map((row, idx) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{idx + 1}</TableCell>

                    <TableCell>{row.title}</TableCell>

                    <TableCell className="max_c2">{row.description}</TableCell>

                    <TableCell>
                      <ul className="feature_list">
                        {row.features.map((f, i) => (
                          <li key={i}>{f}</li>
                        ))}
                      </ul>
                    </TableCell>

                    <TableCell>{row.type}</TableCell>

                    <TableCell>{row.amount}</TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => navigate("add-campaign-type")}>
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Setup Store" {...a11yProps(0)} />
              <Tab label="Store Branding" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs1} index={0}>
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search Campaign..."
                  />
                </Box>
              </div>


            </div>


            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow hover>
                    <TableCell>Sr. No.</TableCell>
                    <TableCell>Field Name</TableCell> {/* Updated label */}
                    <TableCell>View Templates</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {[
                    {
                      id: 1,
                      fieldName: "Store Bio",
                      templateName: "Crafted With AI",
                      createdDate: "05 Jan 2025",
                      status: true,
                    },
                    {
                      id: 2,
                      fieldName: "Store Care Instructions",
                      templateName: "Made in UAE",
                      createdDate: "12 Jan 2025",
                      status: false,
                    },

                  ].map((row, idx) => (
                    <TableRow hover key={row.id}>
                      <TableCell>{idx + 1}</TableCell>

                      {/* Field Name Column */}
                      <TableCell>{row.fieldName}</TableCell>

                      <TableCell>
                        <Button className="btn btn_primary sm" onClick={() => navigate("view-field-templates")}>View</Button>
                      </TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>


            </TableContainer></CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search Campaign..."
                  />
                </Box>
              </div>


            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow hover>
                    <TableCell>Sr. No.</TableCell>
                    <TableCell>Field Name</TableCell> {/* Updated label */}
                    <TableCell>View Templates</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {[
                    {
                      id: 1,
                      fieldName: "Store Motto",
                      templateName: "Crafted With AI",
                      createdDate: "05 Jan 2025",
                      status: true,
                    },
                    {
                      id: 2,
                      fieldName: "Store Story",
                      templateName: "Made in UAE",
                      createdDate: "12 Jan 2025",
                      status: false,
                    }
                  ].map((row, idx) => (
                    <TableRow hover key={row.id}>
                      <TableCell>{idx + 1}</TableCell>

                      {/* Field Name Column */}
                      <TableCell>{row.fieldName}</TableCell>

                      <TableCell>
                        <Button className="btn btn_primary sm" onClick={() => navigate("view-field-templates")}>View</Button>
                      </TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>


            </TableContainer>
          </CustomTabPanel>

        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs2}
              onChange={handleChangeTabs2}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Reedemption" {...a11yProps(0)} />
              <Tab label="Referrals" {...a11yProps(1)} />
              <Tab label="Points Value" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs2} index={0}>
            <div className="form">
              <div className="gap_p">
                <div className="control_group w_33">
                  <label htmlFor="points-per-spend">Set points per 100 AED Spend</label>
                  <TextField placeholder="Enter points" inputProps={{ id: "points-per-spend" }} />
                </div>
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary">Save</Button>
              </div>
            </div>
          </CustomTabPanel>

          <CustomTabPanel value={valueTabs2} index={1}>
            <div className="form">
              <div className="gap_p">
                <div className="control_group w_33">
                  <label htmlFor="points-per-referral">Set points per referral</label>
                  <TextField placeholder="Enter points" inputProps={{ id: "points-per-referral" }} />
                </div>
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary">Save</Button>
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs2} index={2}>
            <div className="form">
              <div className="gap_p">
                <div className="control_group w_33">
                  <label htmlFor="point-value-aed">Set Point Value / 1 Bouteek Point in AED</label>
                  <TextField placeholder="Enter Amount" inputProps={{ id: "point-value-aed" }} />
                </div>
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary">Save</Button>
              </div>
            </div>
          </CustomTabPanel>

        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={4}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="featured-product-fee">Featured Product Fee</label>
                <TextField placeholder="Enter amount" inputProps={{ id: "featured-product-fee" }} />
              </div>
              <div className="control_group w_50">
                <label htmlFor="featured-frequency-days">
                  Featured Product Frequency Period (Days)
                  <Tooltip title="Once a vendor marks a product as featured, they cannot mark another product as featured for this number of days." arrow>
                    <InfoOutlinedIcon sx={{ fontSize: 16, ml: 0.5, verticalAlign: 'middle', cursor: 'pointer', color: '#666' }} />
                  </Tooltip>
                </label>
                <TextField placeholder="Enter days" inputProps={{ id: "featured-frequency-days" }} />
              </div>

              <div className="control_group w_50">
                <label htmlFor="featured-description">Description</label>
                <TextField multiline rows={4} placeholder="Enter Description" inputProps={{ id: "featured-description" }} />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={5}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="return-period-days">Number of Return Period Days</label>
                <TextField placeholder="Enter number of days" type="number" inputProps={{ id: "return-period-days" }} />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={6}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Banner Image</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder no_radius">
                      <figure style={{ width: "200px", height: "200px" }}>
                        <CardMedia component="img" image={image} alt="Signup Banner" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <Input
                      sx={{ display: "none" }}
                      id="signup-banner-image"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const files = e.target.files;
                        if (files && files[0]) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <label className="upload_image" htmlFor="signup-banner-image">
                      <span className="upload_image_holder no_radius">
                        <figure className="add_img" style={{ width: "200px", height: "200px" }}>
                          <img src="/static/images/placeholder.png" alt="placeholder" />
                          <span className="upload_img_icon">
                            <img src="/static/images/edit2_icon.svg" alt="edit" />
                          </span>
                        </figure>
                      </span>
                    </label>
                  </>
                )}
              </div>
            </div>
            <div className="form_btn mt_30">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </div>
        </CustomTabPanel>

        {/* ── Tags Tab ── */}
        <CustomTabPanel value={valueTabs} index={7}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={tagSearchTerm}
                  setDebouncedSearchTerm={setTagSearchTerm}
                  placeholder="Search Tags..."
                />
              </Box>
            </div>
            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => setOpenAddTagModal(true)}>
                <AddIcon /> Add
              </Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Tag Name</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTags.length > 0 ? (
                  filteredTags.map((tag, idx) => (
                    <TableRow hover key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{tag}</TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <IconButton
                            onClick={() => {
                              setSelectedTag(tag);
                              setSelectedTagIndex(tags.indexOf(tag));
                              setOpenAddTagModal(true);
                            }}
                          >
                            <img src="/static/images/edit2_icon.svg" alt="edit" />
                          </IconButton>
                          <IconButton onClick={() => handleDeleteTag(tags.indexOf(tag))}>
                            <img src="/static/images/trash2_icon.svg" alt="delete" />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No tags found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>

      {/* ── Tags Tab Panel ── */}
      <AddTags
        open={openAddTagModal}
        onClose={() => setOpenAddTagModal(false)}
        setOpen={setOpenAddTagModal}
        onAdd={handleAddTag}
      />
    

      <AddQueries
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
      <AddTemplate
        open={openTemplateModal}
        onClose={handleCloseModal1}
        setOpen={setOpenTemplateModal}
      />
      <AddBouteekPoints
        open={openBouteekModal}
        onClose={handleCloseModal2}
        setOpen={setOpenBouteekModal}
      />
    </>
  );
};

export default ManageSystemSettings;
